class ConfiguratorBoxsprings {
    constructor() {
        this.id = 'boxsprings';
        this.cache = {};
        this.mirror_box = null;
        this.allow_none = false;

        this.selectors = [
            'boxsprings',
            'boxsprings-firmness'
        ];

        for (const sel of this.selectors) {
            configurator.addSelectorItem(sel);
        }

        this.init();
    }

    async init() {
    }

    isValidSelector(selector) {
        return this.selectors.includes(selector);
    }

    setupListeners() {
    }

    async refresh(selector) {
        if (configurator.selection.size == null || configurator.selection.fabric == null) {
            configurator.resetSelectorData( this.id );
            return;
        }

        if (!(configurator.selection.size in this.cache && configurator.selection.fabric in this.cache[configurator.selection.size].fabrics)) {
            await this.loadItems(configurator.selection.size, configurator.selection.fabric);
        }

        this.populateBoxSprings();
        this.populateFirmnesses();
    }

    async loadItems(size, fabric) {
        const size_arr = size.split('x');
        const width = parseInt(size_arr[0]); // Used to define is_double
        const is_double = width > 140 ? true : false; // Define is_double based on width


        if (size in this.cache && fabric in this.cache[size]['fabrics']) {
            return; // Already loaded
        }


        if (!(size in this.cache)) {
            this.cache[size] = {
                'title': size, 'fabrics': {}, 'products': {},
            };
        }
        this.cache[size].fabrics[fabric] = {
            'title': fabric, 'products': {},
        };

        const products_with_fabric = await configurator.loadProductData('configurator-box-spring-mattresses', [
            {key: 'size', value: size},
            {key: 'fabric', value: fabric},
        ], []);

        for (const product of products_with_fabric) {
            configurator.applyReferenceProduct(product);

            if (bed_configuration.excluded_skus_global_set && bed_configuration.excluded_skus_global_set.has(product.productid)) {
                continue; // Skip this entire product
            }

            if (bed_configuration.is_adjustable != product.productid.includes('split') && is_double) {
                continue;
            }

            const validFirmnessesData = []; // To store firmness data for variants that pass SKU checks

            for (const variant of product.variants) {
                if (configurator.enable_ecommerce == true && variant.price == 0) { continue; }


                // 2. Variant SKU level exclusion check
                if (bed_configuration.excluded_skus_global_set && bed_configuration.excluded_skus_global_set.has(variant.sku)) {
                    // console.log(`[${this.id}] Variant SKU ${variant.sku} (Product ${product.productid}) IS IN EXCLUSION LIST. Skipping variant.`);
                    continue;
                }

                // If variant is not excluded by its own SKU, prepare its data
                const firm_key = variant.title.toLowerCase().replace(/\s/g, '').replace(/,/g, '-');
                const variantItem = configurator.variantToItem(product, variant); // product here is the one potentially modified by applyReferenceProduct
                variantItem.id = firm_key;
                variantItem.label = variant.title;
                validFirmnessesData.push({ firm_key, data: variantItem });
            }

            // 3. If there are any valid variants after all checks, then add the product and its valid variants to cache
            if (validFirmnessesData.length > 0) {
                // Build Cylindo thumbnail URL (product.cylindo_model might have been set by applyReferenceProduct)
                if (product.cylindo_model != null) {
                    product.image = this.getCylindoThumbnail(product);
                }

                // Add product to cache (using the product.productid after applyReferenceProduct)
                this.cache[size].fabrics[fabric].products[product.productid] = configurator.productToItem(product);
                const productCacheEntry = this.cache[size].fabrics[fabric].products[product.productid];
                productCacheEntry.firmnesses = {};

                // Add the collected valid variants (firmnesses)
                for (const { firm_key, data } of validFirmnessesData) {
                    productCacheEntry.firmnesses[firm_key] = data;
                }
            }
        }
    }

    populateBoxSprings() {
        const size = configurator.selection.size;
        const fabric = configurator.selection.fabric;

        this.items = this.cache[size].fabrics[fabric].products;
        configurator.renderSelector(this.id, Object.values(this.items), {
            'thumbnails': true,
        });
    }

    populateFirmnesses() {
        const size = configurator.selection.size;
        const fabric = configurator.selection.fabric;
        const product = configurator.selection.boxsprings;

        if (configurator.selection.boxsprings == null) {
            configurator.resetSelectorData('boxsprings-firmness');
            return;
        }

        this.items = this.cache[size].fabrics[fabric].products[product].firmnesses;

        configurator.renderSelector('boxsprings-firmness', Object.values(this.items), {
            'columns': 5,
            'allow_none': false,
        });
    }

    isSoldOut() {
        return false;
    }

    getPriceData(priceData) {
        const size = configurator.selection.size;
        const fabric = configurator.selection.fabric;
        const product = configurator.selection.boxsprings;
        const firmness = configurator.selection['boxsprings-firmness'];

        if (size != null && fabric != null && product != null && product in this.cache[size].fabrics[fabric].products
            && firmness != null && firmness in this.cache[size].fabrics[fabric].products[product].firmnesses) {

                const item = this.cache[size].fabrics[fabric].products[product].firmnesses[firmness];

                if (item != null) {
                    const price = item.price ?? 0; //!= undefined ? item.price : 0;
                    console.log("spring mattress"+" => "+item.id+" => "+price);
                    priceData.total += price;
                    if (item.skus.length > 0) { priceData.skus.push(...item.skus); }
                    if (item.ids.length > 0) { priceData.ids.push(...item.ids); }
                }
        }
    }

    getCylindoSpecs(specs) {
        // ============== Translate Box Spring Mattress config ==============
        specs.features['MATTRESS TYPE'] = 'OFF';

        if (configurator.selection.boxsprings != null) {
            if (configurator.selection.boxsprings.includes('lillaharpo')) specs.features['MATTRESS TYPE'] = 'SMALL HARPO';
            else if (configurator.selection.boxsprings.includes('storaharpo')) specs.features['MATTRESS TYPE'] = 'LARGE HARPO';
        }
    }

    getCylindoThumbnail(product) {
        let base_url = bed_configuration.cylindo_base_url + product.cylindo_model + '/frames/3/' + product.cylindo_model + '.jpg?'
            + 'size=512&background=f7f7f7&encoding=jpg';

        // Apply size to thumbnail
        const size_arr = configurator.selection.size.split('x');

        let model_size = '180';
        if (['80', '90', '105'].includes(size_arr[0])) { model_size = '90'; }
        if (['120', '135', '140', '150'].includes(size_arr[0])) { model_size = '140'; }
        if (['160', '180', '200', '210'].includes(size_arr[0])) { model_size = '180'; }

        base_url += `&feature=SIZE:200x${model_size}`;

        // Apply fabric
        const cylindo_fabric = configurator.m3_fabrics[configurator.selection.fabric][0];
        base_url += `&feature=UPHOLSTERY:${cylindo_fabric}`;

        return base_url;
    }
}
